class BackToTop extends window.BAO.CustomElement() {
  static get requiredExternalEls () {
    return ['anchor', 'container', 'list', 'list-item']
  }

  connectedCallback () {
    super.connectedCallback()

    this.observer = new IntersectionObserver(this.handleObservation.bind(this))
    this.observer.observe(this.externalEls.anchor.element)
  }

  setupListeners () {
    super.setupListeners()

    this.els.button.element.addEventListener('click', e => {
      this.handleClick(e)
    })

    this.listeners.add(document, 'renderComplete', e => {
      const list = this.externalEls.list.element
      const pageHeight = list.clientHeight / this.totalPages

      this.externalEls.container.element.style.setProperty(
        '--PageHeight',
        pageHeight,
      )
    })
  }

  /** @type {IntersectionObserverCallback} */
  handleObservation (entries) {
    const isAnchorInView = entries[0].isIntersecting
    this.setAttribute('aria-hidden', !isAnchorInView)
  }

  handleClick (e) {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  get totalPages () {
    const listItems = this.externalEls['list-item']?.elements ?? []
    const pageIndicators = new Set(listItems.map(item => item.dataset.page))
    return pageIndicators.size
  }
}

if (!window.customElements.get('back-to-top')) {
  window.customElements.define('back-to-top', BackToTop)
}
